/** Canonical admin role name (replaces retired Super Admin). */
export const SYSTEM_ADMINISTRATOR_ROLE = 'System Administrator'

export const ADMIN_ROLE_NAMES = [SYSTEM_ADMINISTRATOR_ROLE] as const

export function hasAdminRole(rolenames?: string[] | null): boolean {
  if (!rolenames?.length) {
    return false
  }
  return ADMIN_ROLE_NAMES.some((name) => rolenames.includes(name))
}

export const WYSEAI_PLATFORM_ADMIN_ROLE = 'WyseAi Platform Admin'

/** Internal WyseHub/WyseAi/AiClaims staff — never a partner or client user.
 * Same role pair as the backend's `is_wyseai_platform_admin`. */
const STAFF_ROLE_NAMES = [
  SYSTEM_ADMINISTRATOR_ROLE,
  WYSEAI_PLATFORM_ADMIN_ROLE,
] as const

export function isInternalEmployee(rolenames?: string[] | null): boolean {
  if (!rolenames?.length) {
    return false
  }
  return STAFF_ROLE_NAMES.some((name) => rolenames.includes(name))
}

/** Preserve order; drop duplicates (e.g. mistaken duplicate entries in UI lists). */
export function uniqueInOrder<T>(items: readonly T[]): T[] {
  return [...new Set(items)]
}

/** Roles shown in the sidebar context switcher. */
export function switchableContextRoles(rolenames?: string[] | null): string[] {
  const candidates = ['source', 'supplier', ...ADMIN_ROLE_NAMES] as const
  return uniqueInOrder(candidates.filter((role) => rolenames?.includes(role)))
}
